"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_USER_INFO = exports.SET_PERMISSION = exports.ADD_DATASHEET = exports.UPDATE_WIDGET_CONFIG = exports.SET_ERROR_CODE = void 0;
/** error code */
exports.SET_ERROR_CODE = 'SET_ERROR_CODE';
/** widget config */
exports.UPDATE_WIDGET_CONFIG = 'UPDATE_WIDGET_CONFIG';
/** datasheetMap */
exports.ADD_DATASHEET = 'ADD_DATASHEET';
/** permission */
exports.SET_PERMISSION = 'SET_PERMISSION';
/** user */
exports.SET_USER_INFO = 'SET_USER_INFO';
